<nav aria-label="Breadcrumb">
    <ol class="breadcrumbs">
        <li *ngFor="let item of items; let first = first; let last = last" class="breadcrumbs__item">
            <svg *ngIf="!first" class="breadcrumbs__separator" viewBox="0 0 16 16" aria-hidden="true"><path d="m6 4 4 4-4 4"/></svg>
            <a *ngIf="item.link; else label" [routerLink]="item.link" class="breadcrumbs__link" [attr.aria-current]="isCurrent(item, last) ? 'page' : null">{{ item.label }}</a>
            <ng-template #label><span [class.breadcrumbs__current]="isCurrent(item, last)" [attr.aria-current]="isCurrent(item, last) ? 'page' : null">{{ item.label }}</span></ng-template>
        </li>
    </ol>
</nav>
